import Axios from 'axios';
import Qs from 'qs';

export default {

	//设备类型列表
	listPage(
		name,
		type_code,
		remark,
		page,
		limit
	) {
		return Axios.get('/deviceManage/api/admin/device-type', {
			params: {
				name,
				type_code,
				remark,
				page,
				limit
			},
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		});
	},
	//添加类型
	add(
		name,
		type_code,
		remark,
		maintain,
		inspect,
	) {
		return Axios.post('device-management/device-type/add', {
			name,
			type_code,
			remark,
			maintain,
			inspect,

		});
	},
	//类型详情
	info(
		id
	) {
		return Axios.get(`device-management/device-type/${id}`);
	},

	//修改设备,参数可能需要修改
	edit(
		id,
		name,
		type_code,
		remark,
		maintain,
		inspect,
	) {
		return Axios.patch(`/deviceManage/api/admin/device-type/${id}`, {
			name,
			type_code,
			remark,
			maintain,
			inspect,
		});
	},
	//删除设备
	del(
		id
	) {
		return Axios.delete(`/deviceManage/api/admin/device-type/${id}`)
	}

}